import store from '@/store';
import {Action, Module} from 'vuex-module-decorators';
import {EntityStateAdapter} from '@/store/base.store';
import {ChallengesApi} from '@/api/challenges.api';
import {take} from 'rxjs/operators';
import {PaginatedParams} from '@/api/base.api';
import {ChallengeFileModel} from '@/models/challenge-file.model';

export const featureKey = 'files';

// @ts-ignore
if (store.state.files) {
  store.unregisterModule(featureKey)
}

@Module({
  store,
  dynamic: true,
  name: featureKey,
  namespaced: true,
})
export class FilesStoreModule extends EntityStateAdapter<ChallengeFileModel> {

  get files(): ChallengeFileModel[] {
    return this._entities;
  }

  get currentPage(): number {
    return this._currentPage;
  }

  get loading(): boolean {
    return this._loading;
  }

  get lastPage(): number {
    return this._lastPage;
  }

  @Action({commit: 'insertMany', rawError: true})
  async fetchFiles(data: { challengeId: number, params: PaginatedParams }): Promise<ChallengeFileModel[]> {
    this.updateLoading(true);
    const response = await (new ChallengesApi())
      .getFiles(data.challengeId, data.params)
      .pipe(take(1))
      .toPromise();
    this.context.commit('updateAllPageParams', response);
    return response.data;
  }

  @Action({commit: 'insertMany', rawError: true})
  async fetchAll(data: {
    challengeId: number,
    page?: number,
  }): Promise<ChallengeFileModel[]> {
    this.updateLoading(true);
    const params: PaginatedParams = {
      page: data.page,
    };
    const response = await (new ChallengesApi())
      .getFiles(data.challengeId, params)
      .pipe(take(1))
      .toPromise();

    this.context.commit('updateAllPageParams', response);
    return response.data
  }
}
